require('./bootstrap');
import Alpine from 'alpinejs';

require('livewire-sortable')
window.Pikaday = require('pikaday');
window.Alpine = Alpine;
Alpine.start();
